import { render } from "./ProductoEditorModal.vue?vue&type=template&id=3c22ae58&scoped=true"
import script from "./ProductoEditorModal.vue?vue&type=script&lang=js"
export * from "./ProductoEditorModal.vue?vue&type=script&lang=js"

import "./ProductoEditorModal.vue?vue&type=style&index=0&id=3c22ae58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c22ae58"]])

export default __exports__